module.exports = __webpack_public_path__ + "0ea45a93f28a9a7642f540fa4c59edb9.pdf";